import { IniInfo } from "system/types/interfaces";
import { getRuleSignature, isContentDirty } from "./ruleSignature";

// Compares what the lines say, not the objects. pendingChanges is bookkeeping the editor
// writes on every save, so an object comparison reports a change that is only that flag.
export const haveConfigurationsChanged = (current: IniInfo[], initial: IniInfo[]): boolean => {
  if (current.length !== initial.length) return true;
  return current.some((line, index) => getRuleSignature(line) !== getRuleSignature(initial[index]));
};

// Measured against the signature taken when the policy loaded, not against whatever the
// subject view happened to hold on entry: that ref is rebuilt on every visit, so a line
// added on an earlier visit would look original on the next one. A line with no signature
// never came from the file and is new.
export const isConfigurationLineChanged = (line: IniInfo): boolean => isContentDirty(line);
